export const DEFAULT_LIST_COUNT = 15
export const LIST_CHANGE_ITEM = [15, 30, 50, 100]
export const DOCUMENT_ITEM_TYPE_ARRAY = [
    "복리후생비", "여비교통비", "접대비", "통신비", "수도광열비", "세금과공과",
    "임차료", "보험료", "차량유지비", "운반비", "도서인쇄비", "소모품비", "수수료",
    "광고선전비", "수선비", "교육훈련비", "파출비", "잔반비", "식재료비", "사무용품비",
    "건물관리비", "기타"
].sort()
